export default __webpack_public_path__ + "static/media/logo.84ed7d5b.svg";